import React, { useState } from 'react'
import ApproveModal from '../../../Tasker/ModalComponents/ApproveModal'
import RejectModal from '../../../Tasker/ModalComponents/RejectModal'
import { SubmissionTaskApprove, SubmissionTaskReject } from '../../../../Redux/Actions/TaskCreatorAction'
import { useDispatch } from 'react-redux'

const SubmissionRow = ({ curElem, loader, setLoader, fetchData }) => {
    const proofLink = JSON.parse(curElem.proof_meta_data)
    const [show, setShow] = useState(false)
    const [show1, setShow1] = useState(false)
    const [reason, setReason] = useState()
    const dispatch = useDispatch()
    const handleClose = () => setShow(false)

    const handleShow = () => setShow(true)
    const handleClose1 = () => setShow1(false)

    const handleShow1 = () => setShow1(true)
    const handleConfirm = () => {
        if (curElem.id) {
            setLoader({
                ...loader,
                approve: true

            });
            const data = { id: curElem.id };
            dispatch(SubmissionTaskApprove(data, loader, setLoader, handleClose, fetchData));
        }
    };
    const handleReject = () => {
        if (curElem.id) {
            setLoader({
                ...loader,
                reject: true
            });
            const data = {
                id: curElem.id,
                "reason": reason

            };
            dispatch(SubmissionTaskReject(data, loader, setLoader, handleClose1, fetchData));
        }
    };
    return (
        <>
            <tr>

                <td data-label="Id">{curElem.id}</td>
                <td data-label="Proof"><a href={`https://href.li/?${curElem.proof}`} target="_blank">{curElem.proof}</a></td>
                <td data-label="Proof Data"><a href={`https://href.li/?${proofLink.link || proofLink.file}`} target="_blank">{proofLink.link || proofLink.file}</a></td>
                <td data-label="Status">
                    {curElem.status === "2" ? <div className='earn_status complete' style={{ padding: "5px 20px", width: "fit-content", borderRadius: "50px", backgroundColor: "rgb(222, 248, 238)", color: "rgb(74, 167, 133)" }}>Approved</div> : curElem.status === "3" ? <div className='earn_status' style={{ padding: "5px 20px", width: "fit-content", borderRadius: "50px", backgroundColor: "#f8d7da", color: "#721c24" }}>Rejected</div> : <div className='earn_status' style={{ padding: "5px 20px", width: "fit-content", borderRadius: "50px", backgroundColor: "rgb(255, 243, 205)", color: "rgb(133, 100, 4)" }}>Pending</div>}
                </td>
                <td data-label="Created">{curElem.created}</td>
                <td data-label="Action">
                    {curElem.status === "1" ? <div className='d-flex align-items-center justify-content-end gap-3'>
                        <div className='theme-btn' onClick={handleShow}>Approve</div>
                        <div className='theme-btn' onClick={handleShow1}>Reject</div>
                    </div> : ""}
                </td>

            </tr>
            <ApproveModal
                show={show}
                handleClose={handleClose}
                loader={loader}
                handleConfirm={handleConfirm}
            />
            <RejectModal
                show={show1}
                handleClose={handleClose1}
                handleReject={handleReject}
                setReason={setReason}
                loader={loader}
                reason={reason}
            />
        </>
    )
}

export default SubmissionRow
